/** @fileoverview Loads Fabrik plan usage from the shared billing service. */

import type { BillingUsage } from '../types/billing';
import { json } from './platformAuth';

export const getFabrikUsage = async (tenantId: string, signal?: AbortSignal) => {
  const usage = await json<BillingUsage[]>(
    `/app/billing/tenant/${encodeURIComponent(tenantId)}/usage?applicationCode=fabrik`,
    tenantId,
    { signal }
  );
  return usage.find((plan) => plan.application_code === 'fabrik') || null;
};
